import React from "react";
import DateHelper from "../DateHelper/DateHelper";

class PaymentGatewayTesterMessage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    //console.log("PaymentGatewayTesterMessage", this.props);
    if (this.props.mode === "test" && this.props.currentStep === "") {
      if (this.props.gateway && this.props.gateway.tested_successfully_at) {
        return (
          <div className="text-center">
            <div className="alert alert-success ignore text-center">
              <strong>{I18n.t("success")}:</strong>{" "}
              {I18n.t("gateway_last_tested_on")}{" "}
              {DateHelper.printDateToScreen(
                DateHelper.local(this.props.gateway.tested_successfully_at),
                this.props.date_format + " - " + this.props.time_format
              )}
              {this.authorization()}
            </div>
          </div>
        );
      } else {
        return (
          <div className="text-center">
            <div className="alert alert-danger ignore text-center">
              <strong>{I18n.t("warning")}:</strong>{" "}
              {I18n.t("gateway_not_yet_tested")}
              {this.authorization()}
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }

  authorization() {
    if (this.props.gateway.authorization) {
      return (
        <span className="paymentId">
          {I18n.t("payment_id")}: <em>{this.props.gateway.authorization}</em>
        </span>
      );
    } else {
      return null;
    }
  }
}

export default PaymentGatewayTesterMessage;
